import ExcelJS, { Border } from "exceljs";

export const JsonToCsv = (myJSON, columns, fileName="report", specialCells?, center?, notes?) => {
    const workbook = new ExcelJS.Workbook();
    const sheet = workbook.addWorksheet("New Report");

    let setBorder: Partial<Border> = { style: "thin", color: { argb: "999999" } }
    sheet.getRow(1).border = {
        top: setBorder,
        left: setBorder,
        bottom: setBorder,
        right: setBorder,
    };

    sheet.getRow(1).fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "cfe2f3" },
    };
    sheet.getRow(1).height = 45;

    sheet.getRow(1).font = {
        name: "Muli",
        family: 4,
        size: 12,
        bold: true
    };
    sheet.getRow(1).alignment = {
        vertical: "middle",
        horizontal: "center",
        wrapText: true,
    };

    const headerRow = sheet.getRow(1);
    if(notes){
        columns.forEach((col, index) => {
            if(col.comment){
                const cell = headerRow.getCell(index + 1);
                cell.value = col.header;
                cell.note = {
                    texts: [{ text: col.comment }]
                };
            }
        });
    };

    sheet.columns = columns;
    sheet.views = [{state: 'frozen', xSplit: 1, ySplit: 1}]

    myJSON?.map((item) => {
        return sheet.addRow(item);
    });

    sheet.eachRow(function(row, i){
        if(i > 1){
            row.font = {
                name: "Muli",
                family: 4,
            }
            if (center) {
                row.alignment = { vertical: "middle", horizontal: center }
            }
            return row.height = 20
        }
    });

    if(specialCells){
        sheet.addConditionalFormatting({
            ref: specialCells.iconRef,
            rules: specialCells.rules
        })
    }

    workbook.xlsx.writeBuffer().then((data) => {
        const url = window.URL.createObjectURL(
            new Blob([data], {type: "application/vnd.openxmlformats-officedocument.spreadsheet.sheet"})
        );
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `${fileName}.xlsx`);
        document.body.appendChild(link);
        link.click();
        window.URL.revokeObjectURL(url);
    });
};
